import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const fetchBarometer = (period) => api.get("/barometer", { params: { period } }).then((r) => r.data);
export const refreshBarometer = () => api.post("/barometer/refresh").then((r) => r.data);
export const fetchTrend = () => api.get("/barometer/trend").then((r) => r.data);
export const fetchHappiness = () => api.get("/happiness").then((r) => r.data);
export const fetchSources = () => api.get("/sources").then((r) => r.data);
export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchVolunteers = (params) => api.get("/volunteers", { params }).then((r) => r.data);
export const fetchVolunteerMeta = () => api.get("/volunteers/meta").then((r) => r.data);
export const fetchVolunteerAnalytics = () => api.get("/volunteers/analytics").then((r) => r.data);
export const fetchVolunteerDetail = (id) => api.get(`/volunteers/${id}`).then((r) => r.data);
export const geoPostal = (code) => api.get("/geo/postal", { params: { code } }).then((r) => r.data);
export const fetchFundraisers = (params) => api.get("/fundraisers", { params }).then((r) => r.data);
export const fetchEvents = (params) => api.get("/events", { params }).then((r) => r.data);
export const fetchCommunityStats = () => api.get("/community/stats").then((r) => r.data);
export const fetchPulse = (params) => api.get("/pulse", { params }).then((r) => r.data);
export const fetchPulseMeta = () => api.get("/pulse/meta").then((r) => r.data);
export const fetchPulseItem = (id) => api.get(`/pulse/${id}`).then((r) => r.data);
